import MapboxDraw, { DrawCustomMode, DrawCustomModeThis } from "@mapbox/mapbox-gl-draw";

import drawPoint from "fond/draw/modes/base/drawPoint";
import drawAerialPole from "fond/draw/modes/planner/aerial/drawAerialPole";
import { LayerIds } from "fond/types";

/**
 * A composite draw_point mode that merges base and aerial behavior.
 *
 * When the editingLayerId is inPole, delegates onClick to drawAerialPole which
 * creates poles with snapping, handles colocation checks, and splits spans.
 *
 * For all other layers, uses the base drawPoint behavior.
 */
const compositeDrawPoint: DrawCustomMode = {
  ...drawPoint,

  onClick(this: DrawCustomModeThis, state: Record<string, unknown>, event: MapboxDraw.MapMouseEvent) {
    const editingLayerId = this._ctx.options.editOptions?.editingLayerId;

    if (editingLayerId === LayerIds.inPole) {
      // @ts-expect-error ThisType constraints too strict for composite delegation
      return drawAerialPole.onClick?.call(this, state, event);
    }

    // @ts-expect-error ThisType constraints too strict for composite delegation
    return drawPoint.onClick?.call(this, state, event);
  },
};

export default compositeDrawPoint;
